import { API_ROOT } from 'environment';

angular.module('app.resources').factory('Broadcast', ($q, $resource) => {

    var Broadcast = $resource(`${API_ROOT}/broadcasts/:id`, { id: '@id' }, {
        create: {
            method: 'POST',
            url: `${API_ROOT}/broadcasts`,
            transformRequest: function(data, headersGetter) {
                if (data.stream_source === 'boxcaster-pro') {
                    data.stream_source = 'boxcaster';
                }
                return angular.toJson(data);
            }
        },
        get: {
            method: 'GET',
            transformResponse: function(data, headersGetter, status) {
                data = angular.fromJson(data);
                // Give BoxCaster Pros a unique stream_source ('boxcaster-pro')
                if ((data.stream_source === 'boxcaster') && (data.boxcaster_id[0] === 'p')) {
                    data.stream_source = 'boxcaster-pro';
                }
                return data;
            }
        },
        update: {
            method: 'PUT',
            transformRequest: function(data, headersGetter) {
                if (data.stream_source === 'boxcaster-pro') {
                    data.stream_source = 'boxcaster';
                }
                return angular.toJson(data);
            },
            transformResponse: function(data, headersGetter, status) {
                data = angular.fromJson(data);
                // Give BoxCaster Pros a unique stream_source ('boxcaster-pro')
                if ((data.stream_source === 'boxcaster') && (data.boxcaster_id[0] === 'p')) {
                    data.stream_source = 'boxcaster-pro';
                }
                return data;
            }
        },
        undelete: {
            method: 'POST',
            url: `${API_ROOT}/broadcasts/:id/undelete`
        },
        query: {
            method: 'GET',
            isArray: true,
            transformResponse: function(data, headersGetter, status) {
                data = angular.fromJson(data);
                // Give BoxCaster Pros a unique stream_source ('boxcaster-pro')
                _.each(data, function (b) {
                    if ((b.stream_source === 'boxcaster') && (b.boxcaster_id[0] === 'p')) {
                        b.stream_source = 'boxcaster-pro';
                    }
                    if (b.scoreboard_configuration) {
                        b.scoreboard_configuration.sport_icon = (b.scoreboard_configuration.sport || '').toLowerCase();
                        if (b.scoreboard_configuration.sport_icon.startsWith('basketball')) {
                          b.scoreboard_configuration.sport_icon = 'basketball';
                        }
                        if (b.scoreboard_configuration.sport_icon.startsWith('baseball')) {
                          b.scoreboard_configuration.sport_icon = 'baseball';
                        }

                        b.scoreboard_configuration.make_icon = (b.scoreboard_configuration.scoreboard_make || '').toLowerCase();
                        if (!b.scoreboard_configuration.sport) {
                            b.scoreboard_configuration.make_icon = '';
                        }

                        if (b.scoreboard_configuration.make_icon.startsWith('daktronics')) {
                            b.scoreboard_configuration.make_icon = 'automated_scoreboard';
                        }
                        if (b.scoreboard_configuration.make_icon.startsWith('trans')) {
                            b.scoreboard_configuration.make_icon = 'automated_scoreboard';
                        }
                        if (b.scoreboard_configuration.make_icon.startsWith('oes')) {
                            b.scoreboard_configuration.make_icon = 'automated_scoreboard';
                        }
                        if (b.scoreboard_configuration.make_icon.startsWith('boxcast')) {
                            b.scoreboard_configuration.make_icon = 'scoreboard_assist';
                        }
                    }
                });
                return data;
            }
        },
    });

    Broadcast.queryAll = function(params) {
        let broadcasts = [];
        let d = $q.defer();
        let paramsCopy = angular.copy(params);
        paramsCopy.p = 0;
        Broadcast.query(paramsCopy, (results, headers) => {
          broadcasts = broadcasts.concat(results);
          let pagination = JSON.parse(headers('x-pagination'));
          if (!pagination || !pagination.last) {
            d.resolve(broadcasts);
            return;
          }
          var promises = [];
          for (var p = 1; p <= pagination.last; p++) {
            let paramsCopy2 = angular.copy(params);
            paramsCopy2.p = p;
            promises.push(
              Broadcast.query(paramsCopy2, (results) => {
                broadcasts = broadcasts.concat(results);
              }).$promise
            );
          }
          $q.all(promises).then(() => {
            d.resolve(broadcasts);
          }).catch((e) => d.reject(e))
        }, (err) => {
          d.reject(err);
        });
        return d.promise;
    };

    return Broadcast;
  }
);



// WEBPACK FOOTER //
// ./resources/broadcast.js